import { defaultCampaignCreateState, CampaignState } from "../state";
import { generatePDFOfferAction, generatePDFOfferActionFinished, generatePDFOfferActionError } from "./actions";
import { Action } from "redux";
export function downloadPdfReducer(state: CampaignState = defaultCampaignCreateState, action: Action): CampaignState {
    switch (action.type) {
        case generatePDFOfferAction.type: {
            return {
                ...state,
                generatePdfOffer: "LOADING"
            };
        }
        case generatePDFOfferActionFinished.type: {
            return {
                ...state,
                generatePdfOffer: "LOADED"
            };
        }
        case generatePDFOfferActionError.type: {
            return {
                ...state,
                generatePdfOffer: "ERROR"
            };
        }
    }
    return state;
}
